var id = 100000;
export function generateId() {
  id += 1;
  return id.toString();
}